import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInstagram,
  faFacebook,
  faGithub,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhoneSquare } from '@fortawesome/free-solid-svg-icons';
import PolicyModal from '../PolicyText/PolicyModal';
import ArrowToTop from '../arrowToTop/ArrowToTop';

const Footer = () => {
  const { t } = useTranslation('common');
  const [activePolicy, setActivePolicy] = useState(null);

  const openPolicy = (policyType) => setActivePolicy(policyType);
  const closePolicy = () => setActivePolicy(null);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__wrapper">
          <ul className="social">
            <li className="social__item">
              <a href="tel:+358468130887" aria-label="Phone">
                <FontAwesomeIcon icon={faPhoneSquare} />
              </a>
            </li>
            <li className="social__item">
              <a
                href="https://www.instagram.com/pixelcraft.fi/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </li>
            <li className="social__item">
              <a
                href="https://github.com/maikamp-ven"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </li>
            <li className="social__item">
              <a
                href="https://www.facebook.com/profile.php?id=61567865667907"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
            </li>
            <li className="social__item">
              <a
                href="https://wa.me/358468130887"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
            </li>
            <li className="social__item">
              <a href="mailto:info@pixelcraft.fi" aria-label="Email">
                <FontAwesomeIcon icon={faEnvelope} />
              </a>
            </li>
          </ul>

          <div className="footer__legal">
            <button
              className="footer__legal-link"
              onClick={() => openPolicy('privacy')}
            >
              {t('footer.privacyPolicy')}
            </button>

            <button
              className="footer__legal-link"
              onClick={() => openPolicy('cookies')}
            >
              {t('footer.cookiePolicy')}
            </button>

            <button
              className="footer__legal-link"
              onClick={() => openPolicy('terms')}
            >
              {t('footer.termsOfUse')}
            </button>
          </div>

          <div className="footer__bottom">
            <p className="footer__copyright">
              {t('footer.rightsReserved')}
            </p>
          </div>
        </div>
      </div>

      <ArrowToTop />

      <PolicyModal
        isOpen={!!activePolicy}
        onClose={closePolicy}
        policyType={activePolicy}
      />
    </footer>
  );
};

export default Footer;